import { useCallback, useEffect, useRef, useState } from "react";

export function useInView(rootMargin = "200px"): [React.RefCallback<Element>, boolean] {
    const [inView, setInView] = useState(false);
    const elementRef = useRef<Element | null>(null);
    const observerRef = useRef<IntersectionObserver | null>(null);

    useEffect(() => {
        observerRef.current = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setInView(true);
                    observerRef.current?.disconnect();
                }
            },
            { rootMargin },
        );
        if (elementRef.current) observerRef.current.observe(elementRef.current);
        return () => observerRef.current?.disconnect();
    }, [rootMargin]);

    const ref = useCallback((node: Element | null) => {
        elementRef.current = node;
        if (node && observerRef.current) {
            observerRef.current.observe(node);
        }
    }, []);

    return [ref, inView];
}
